import React, { SVGProps } from 'react';

interface IconProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

const Info = ({ color = '#FCCB18', ...props }: IconProps) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  (<svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="Info">
    <path
      d="M8 15.5a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15ZM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12Zm-.75-9.75h1.5v1.5h-1.5v-1.5Zm0 3h1.5v4.5h-1.5v-4.5Z"
      fill={color}
    />
  </svg>)
);

export default Info;
